import { ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, OnDestroy} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {BasePage} from "~/app/pages/base.page";
import {InteractionTimer} from "~/app/core/interaction.service";
import {CoreService} from "~/app/core/core.service";
import {Title} from "@angular/platform-browser";

@Component({
    selector: "Welcome",
    templateUrl: "./welcome.page.html",
    styleUrls: ["./welcome.page.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WelcomePage extends BasePage implements OnDestroy {
    private pageTimer: InteractionTimer;

    constructor(
        private readonly ngZone: NgZone,
        private readonly cd: ChangeDetectorRef,
        private readonly core: CoreService,
        private readonly route: ActivatedRoute,
        private readonly title: Title,
    ) {
        super();
        this.core.api.interactOther({ pgWelcomeCount: 1 });
        this.pageTimer = this.core.api.interactTimerOther("pgWelcomeTime");
        this.title.setTitle('Welcome');
    }
    ngOnDestroy() {
        this.pageTimer.log();
    }
    signIn(e): void {
      this.core.nav.navPageLogin();
    }
    signUp(e): void {
      this.core.nav.navPageSignup();
    }
}
